import {Injectable, EventEmitter} from '@angular/core'
import {ClientModel, RiskProfileNotifications} from '../insa-models'
//import { appConfig } from '../../insaweb.config'
//import {LocalizeService} from '../insa-services/localize.service'
import {AuthService} from '../insa-services';


@Injectable()
export class appStateProvider extends EventEmitter<string> {    
    startDate: Date;
    endDate: Date;
    selectedCurrency = {value:0, text:""};
    selectedPortfolios: ClientModel[];
    selectedPartner = {value:0, text:""};
    selectedPartners: number[];
    reportByPartner:boolean = false;
    forceProcessingOnPortfolioLevel: boolean = false;
    forceConsolidateAllPositions: boolean = false;
    showClosedPortfolios: boolean = false;
    fetchingSecurityPrices: boolean = false;
    fetchingAssetCategory: boolean = false;
    fetchingCurrAnalysis: boolean = false;
    fetchingPerfomanceBarChart: boolean = false;
    fetchingPortfolioDetails: boolean = false;
    fetchingTransVolume:boolean = false;
    fetchingCrossRates: boolean = false;
    fetchingPortfolios: boolean = false;
    fetchingTransactions: boolean = false;
    fetchingNews: boolean = false;
    fetchingReport:boolean = false;
    fetchingPDF: boolean = false;
    fetchingClientContacts:boolean = false;
    fetchingRiskProfiles: boolean = false;
    fetchingRiskProfileQuestions: boolean = false;
    fetchingGenericData: boolean = false;
    fetchingChronosJob: boolean = false;
    fetchingChronosPostActivities: boolean = false;
    fetchingPartnerEmails: boolean = false;
    includeIgnoredTransactions: boolean  = false;
    riskProfileNotifications: RiskProfileNotifications = {
      partnerValue: 0,
      profileExpired: false,
      profileExpiresSoon: false,
      noProfile: false
    };
    
    constructor(private _authService: AuthService){
        super()
        console.log("appStateProvider instance created!");
        _authService.LoggedInStatusChangedEmitter.subscribe(loggedIn => {
            if (!loggedIn.value) {
                this.resetVars();
            }
        });
    }

    // this functions is called once user logs out
    // we need to clear some state e.g. selectedPartner
    resetVars () {
        this.startDate = undefined;
        this.endDate = undefined;
        this.selectedCurrency = {value:0, text:""};
        this.selectedPortfolios = [];
        this.selectedPartner = {value:0, text:""};
        this.selectedPartners = [];
        this.riskProfileNotifications = {
          partnerValue: 0,
          profileExpired: false,
          profileExpiresSoon: false,
          noProfile: false
        };
    }

 updateLayout() {
   // console.log('updateLayout')
   if (window.innerWidth > 1199 && !this._authService.embeddedToken ) {
     let sidebar = $("#sidebar");
     if (sidebar.hasClass('active')) {
         $('#wrapper').css("padding-left", "55");
         $('#filter').css('width', 'calc(100% - 55px)');
         $('#filter').css('margin-right', '-55px');
     } else {
         $('#wrapper').css("padding-left", "190");
         $('#filter').css('width', 'calc(100% - 190px)');
         $('#filter').css('margin-right', '-190px');
     }
   } else {
     $('#filter').css('width', '100%');
     $('#wrapper').css("padding-left", "0");
   }

      if(window.innerWidth > 768){
        // $("#home").css("height", (window.innerHeight - $(".navbar-inverse").height() -  $("#tiles").height()) - 10);
        // $("#home").css("height", (window.innerHeight - $(".navbar-inverse").height() -  $("#tiles").height() - $(".cardup").height()- 44));
        // console.log('>> home: ' + $('#home').height())
        $(".canvas").css("height", (window.innerHeight - $(".navbar-inverse").height()- $("#tiles").height() - 5 ));
        $(".gridResize").css("height", (window.innerHeight - $(".navbar-inverse").height()- $("#tiles").height() - $(".resize-header").height() - 5 ));
        let pvwr = $("#pivotviewer");
        if (pvwr.hasClass('modal')) {
            pvwr.css("height", (window.innerHeight - 20));
        } else {
            pvwr.css("height", (window.innerHeight - $(".navbar-inverse").height() - 20));
        }

        $("#newsComponent").css("height", $(".card").height());
        $("#carousel-generic  .carousel-inner").css("height", $("#newsComponent").height());
        $("#carousel-generic .item").css("height", $("#newsComponent").height());
        $("#performanceCanvas").css("height", $(".card").height());
        $("#insaWebDonut").css("height", $(".card").height());
        $("#genericDonutCarousel .item").css("height",  $("#insaWebDonut").height());
        $("#performanceCarousel .item").css("height",  $("#performanceCanvas").height());
        $("#GenericExRates").css("height", $(".card").height());

        let assetCategory: kendo.dataviz.ui.Chart = $("#AssetCategory").data("kendoChart");
        let currencyAnalysis: kendo.dataviz.ui.Chart = $("#CurrencyAnalysis").data("kendoChart");
        let secPricesChart: kendo.dataviz.ui.StockChart = $("#GenericSecurityPrices").data("kendoStockChart");
        let performanceDetailsChart: kendo.dataviz.ui.Chart = $("#PerformanceDetails").data("kendoChart");
        let transGrid: kendo.ui.Grid = $("#TransactionsGrid").data("kendoGrid");
        let portfGrid: kendo.ui.Grid = $("#PortfolioGrid").data("kendoGrid");
        let crossRatesGrid: kendo.ui.Grid = $("#ExRatesGrid").data("kendoGrid");

        if (assetCategory !== undefined && currencyAnalysis !== undefined) {
            assetCategory.options.chartArea = {background: "", width: $('#genericDonutCarousel').width(), height: $('#genericDonutCarousel').height() }
            assetCategory.redraw();

            currencyAnalysis.options.chartArea = {background: "", width: $('#genericDonutCarousel').width(), height: $('#genericDonutCarousel').height() }
            currencyAnalysis.redraw();
        }

        if (secPricesChart !== undefined) {
            secPricesChart.options.chartArea = {background: "", height: $(".canvas").height() - $("#customButtonRow").height()};
            secPricesChart.redraw();
        }
        if (performanceDetailsChart !== undefined) {
            performanceDetailsChart.options.chartArea = {background: "",height:  $("#performanceCanvas").height()};
            performanceDetailsChart.redraw();
        }

        if(transGrid!== undefined){
            transGrid.options.height = $('.gridResize').height();
            transGrid.resize();
        }

        if (portfGrid !== undefined) {
            portfGrid.options.height = $('.gridResize').height();
            portfGrid.resize();
        }

         if (crossRatesGrid !== undefined) {
            crossRatesGrid.options.height = $('.gridResize').height();
            crossRatesGrid.resize();
        }
    }

    }
}


// WEBPACK FOOTER //
// ./app/insa-providers/AppStateProvider.ts